export function toCurrencyString(value) {
  if (value == null || value === '') { // check null or undefined or empty string
    return ''
  } else {
    const num = (typeof value === 'number') ? value : Number(value)
    return `$${num.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}`
  }
}
